import { Box, Container, Divider, Grid, Link, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';

import BigLogo from '../../components/BigLogo';

const LINKS = [
  {
    headline: 'DebitCredit',
    children: [
      { name: 'About us', href: '/about-us' },
      { name: 'Contact us', href: '/contact-us' },
      { name: 'FAQs', href: '/questions' },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: '/terms-and-conditions' },
      { name: 'Privacy Policy', href: '/privacy-policy' },
    ],
  },
  {
    headline: 'Contact',
    children: [{ name: 'support@devfik.com', href: '#' }],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 6 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <BigLogo sx={{ width: 150, height: 60, mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>
          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              A platform aims to provide a comprehensive solution for managing personal income and expenses.
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              {/* <SocialsButton sx={{ mx: 0.5 }} /> */}
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => (
                <Stack key={list.headline} spacing={2}>
                  <Typography component="p" variant="overline">
                    {list.headline}
                  </Typography>
                  {list.children.map((link) => (
                    <Link
                      to={link.href}
                      key={link.name}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      underline="none"
                      sx={{ display: 'block' }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Typography
            component="p"
            variant="body2"
            sx={{
              mt: 6,
              pb: 5,
              fontSize: 13,
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            © {moment().format('YYYY')} DebitCredit
          </Typography>
          <a href="https://status.devfik.com/" target="_blank" rel="noopener noreferrer">
            <img src="https://uptime.betterstack.com/status-badges/v3/monitor/1zhvk.svg" alt="uptime status" />
          </a>
        </Box>
      </Container>
    </RootStyle>
  );
}
